<template>
    <div class="lang">
        <div class="info">
            <h3 class="bullet01">探视时间</h3>
            <p class="bullet03 depth">为确保患者安全与预防感染，探视时间有所限制，请遵守时间.</p>
            <p class="bullet03 depth">探视时间限制在2小时以内，平日(18:00~20:00),周末与节假日(10:00~12:00,18:00~20:00)，20:00点以后禁止进出病房.</p>
            <p class="bullet03 depth">重症患者室的探视时间为13:00~13:30,19:00~19:30.</p>
            <p class="bullet03 depth">持有办理入院手续时提供的陪护人出入证的陪护人可以随时出入.</p>
            <p class="bullet03 depth">患者因免疫力下降或感染疾病隔离的情况，为了预防感染传播和保护患者，限制探视.</p>
            <p class="bullet03 depth">因个人隐私拒绝探视时，请提前通知给登记处或护士室.</p>
            <p class="bullet03 depth">为管理访客，须填写访客名，敬请协助.</p>
        </div>
        <div class="info">
            <h3 class="bullet01">探视限制</h3>
            <p class="bullet03 depth">为使患者迅速康复和病情稳定, 并防止感染, 禁止13岁或不满13岁的儿童前往感染病房和重症监护室.</p>
            <p class="bullet03 depth">如果监护人患有感冒或其他传染病, 可以限制监护人的探视.</p>
            <p class="bullet03 depth">植物, 花盆或动物等任何潜在的感染源都不能带入病房.</p>
        </div>
    </div>
</template>
<script>
    export default {

    }
</script>